import React, { useEffect, useState } from 'react'
import {
  collectionGroup,
  query,
  where,
  onSnapshot,
  orderBy
} from 'firebase/firestore'
import GlobalConfig from '../GlobalConfig'
import ViewIncidents from './ViewIncidents'
import { I18n } from 'galarm-config'
import { DateTimeUtils } from 'galarm-shared'

const MemberIncidents = ({ member, filter = 'none' }) => {
  const enterpriseAccountId = window.localStorage.getItem('enterpriseAccountId')

  const [incidents, setIncidents] = useState([])

  useEffect(() => {
    const incidentsQuery = query(
      collectionGroup(GlobalConfig.firestoreDb, 'incidents'),
      where('enterpriseAccountId', '==', enterpriseAccountId),
      orderBy('timestamp', 'desc')
    )

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(incidentsQuery, incidentsSnapshot => {
      const updatedIncidents = incidentsSnapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(incident => {
          const incidentAlarms = incident.alarms || []
          return incidentAlarms.some(alarm =>
            alarm.members.some(assignee => assignee.id === member.id)
          )
        })
      setIncidents(updatedIncidents) // Directly update state with the new array
    })

    return () => unsubscribe() // Cleanup listener on unmount
  }, [member, enterpriseAccountId]) // Added dependencies to ensure reactivity

  const columns = [
    {
      label: I18n.t('name'),
      key: 'name',
      render: incident => incident.identifier + '-' + incident.alertName
    },
    {
      label: I18n.t('timestamp'),
      key: 'timestamp',
      render: incident =>
        DateTimeUtils.getDateTimeWoYearAsString(incident.timestamp)
    },
    {
      label: I18n.t('status'),
      key: 'status'
    }
  ]

  return (
    <ViewIncidents
      filter={filter}
      incidents={incidents}
      columns={columns}
      header={I18n.t('incidentsForMember', { name: member.firstName })}
      emptyMessage={I18n.t('noIncidentsForMember')}
    />
  )
}

export default MemberIncidents
